module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "consultantWraper",
    staticClass: "consultant-list clearfix"
  }, _vm._l((_vm.consultantList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "consultants__item"
    }, [_c('div', {
      staticClass: "consultants__item-box clearfix",
      on: {
        "click": function($event) {
          _vm.itemClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "consultants__img"
    }, [_c('img', {
      attrs: {
        "src": item.logoUrl,
        "alt": item.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "consultants__desc"
    }, [_c('div', {
      staticClass: "consultants__name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "consultants__job"
    }, [_vm._v(_vm._s(item.profession))]), _vm._v(" "), _c('div', {
      staticClass: "consultants__phone"
    }, [_c('span', {
      staticClass: "iconfont phone"
    }, [_vm._v("")]), _vm._v("：" + _vm._s(_vm.prefix(item.phone)))]), _vm._v(" "), _c('div', {
      staticClass: "consultants__wechat"
    }, [_c('span', {
      staticClass: "iconfont wechat"
    }, [_vm._v("")]), _vm._v("：" + _vm._s(item.wechat))]), _vm._v(" "), _c('div', {
      staticClass: "consultants__order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.order(item)
        }
      }
    }, [_vm._v("立即预约")])])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3f25fd42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/consultant/consultant-list.vue
// module id = 597
// module chunks = 1